<div [class]="'nav-button ' + direction">
  <a *ngIf="link$ | async as l" [routerLink]="l.url" [queryParams]="{query: SearchProductRequest.uriEncode(l.query)}">
    <markant-icon *ngIf="direction === 'left'" src="./assets/svg/chevron-left--dense.svg"></markant-icon>
    <markant-icon *ngIf="direction === 'right'" src="./assets/svg/chevron-right--dense.svg"></markant-icon>
  </a>
</div>
